module.exports = __webpack_public_path__ + "static/img/47.11b0b1e8.png";